import { DoorConfiguration as contex } from '../DoorConfiguration';
import copyObject, * as helper from './Shared';
import store from '@/store/index';
import { Characteristic, ValueDefinition } from '../types';

// KTU_MM_SPIONVERL_ANZ
export const calculateSPIONVERLANZ = () => {
    let result: number = 0;
    let doorThickness: number = 0;
    const newDoorThickness = helper.GetMainCharacteristicValue('KTU_MM_TUERBLATT_DICKE_NEU', contex.Functions);

    const escapeDoor = helper.GetDependencyValueCode('KTU_MM_FLUCHT', contex.ModelSelection); // en179
    const panicDoor = helper.GetDependencyValueCode('KTU_MM_PANIK', contex.ModelSelection); // en1125

    const en179 = escapeDoor === 'JA' ? true : false;
    const en1125 = panicDoor === 'JA' ? true : false;

    const spySelection = Number(helper.GetDependencyValueCode('CUST_MM_SPION', contex.ExteriorAccessory));

    if (en179 === false && en1125 === false) {
        if (spySelection >= 1 && spySelection <= 4) {
            if (newDoorThickness <= 60) {
                result = 0 + 1;
            } else if (newDoorThickness <= 66) {
                result = 1 + 1;
            } else if (newDoorThickness <= 86) {
                result = 2 + 1;
            } else if (newDoorThickness <= 96) {
                result = 3 + 1;
            } else if (newDoorThickness <= 106) {
                result = 4 + 1;
            }
        } else if (spySelection >= 5 && spySelection <= 10) {
            doorThickness = newDoorThickness + 6;

            if (doorThickness <= 55) {
                result = 0 + 1;
            } else if (doorThickness <= 56) {
                result = 1 + 1;
            } else if (doorThickness <= 66) {
                result = 2 + 1;
            } else if (doorThickness <= 86) {
                result = 3 + 1;
            } else if (doorThickness <= 96) {
                result = 4 + 1;
            } else if (doorThickness <= 106) {
                result = 5 + 1;
            }
        } else {
            result = 0;
        }
    } else if (en1125 === true) {
        if (spySelection >= 1 && spySelection <= 5) {
            if (newDoorThickness <= 60) {
                result = 0;
            } else if (newDoorThickness <= 66) {
                result = 1;
            } else if (newDoorThickness <= 86) {
                result = 2;
            } else if (newDoorThickness <= 96) {
                result = 3;
            } else if (newDoorThickness <= 106) {
                result = 4;
            }
        } else if (spySelection >= 6 && spySelection <= 12) {
            doorThickness = newDoorThickness + 6;

            if (doorThickness <= 55) {
                result = 0;
            } else if (doorThickness <= 56) {
                result = 1;
            } else if (doorThickness <= 66) {
                result = 2;
            } else if (doorThickness <= 86) {
                result = 3;
            } else if (doorThickness <= 96) {
                result = 4;
            } else if (doorThickness <= 106) {
                result = 5;
            }
        } else {
            result = 0;
        }
    } else if (en179 === true) {
        if (spySelection >= 1 && spySelection <= 5) {
            if (newDoorThickness <= 60) {
                result = 0;
            } else if (newDoorThickness <= 66) {
                result = 1;
            } else if (newDoorThickness <= 86) {
                result = 2;
            } else if (newDoorThickness <= 96) {
                result = 3;
            } else if (newDoorThickness <= 106) {
                result = 4;
            }
        } else if (spySelection >= 6 && spySelection <= 12) {
            doorThickness = newDoorThickness + 6;

            if (doorThickness <= 55) {
                result = 0;
            } else if (doorThickness <= 56) {
                result = 1;
            } else if (doorThickness <= 66) {
                result = 2;
            } else if (doorThickness <= 86) {
                result = 3;
            } else if (doorThickness <= 96) {
                result = 4;
            } else if (doorThickness <= 106) {
                result = 5;
            }
        } else {
            result = 0;
        }
    }

    return result;
};

// KTU_MM_BOHRUNG_AZ
export const calculateBOHRUNGAZ = () => {
    let result: number = 0;

    const doorOpeningWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);
    const doorType = helper.GetDependencyValueCode('KTU_MM_ANWENDUNG', contex.ModelSelection);
    const numberOfDoorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const aussenzylinder: Number = Number(helper.GetDependencyValueCode('CUST_MM_KASTENR_AUSSENZYLINDER', contex.ExteriorAccessory));

    if ((doorOpeningWay === 'LI' || doorOpeningWay === 'RI') && doorType !== 'ATF') {
        if (numberOfDoorWings === 'D1') {
            switch(aussenzylinder){
                case 1:
                case 2:
                    result = 0;
                    break;
                case 3:
                case 4:
                case 5:
                    result = 1300;
                    break;
            }
        } else {
            result = 0;
        }
    } else {
        result = 0;
    }

    return result;
};

// KTU_MM_BOHRUNG_AZ
export const bohrungazStatus = () =>{
    let status: boolean = true;

    const doorOpeningWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);
    const doorType = helper.GetDependencyValueCode('KTU_MM_ANWENDUNG', contex.ModelSelection);
    const numberOfDoorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    if ((doorOpeningWay === 'LI' || doorOpeningWay === 'RI') && doorType !== 'ATF') {
        if (numberOfDoorWings === 'D1') 
            status = false;
    }

    return status;
}

// KTU_MM_KR_DISTANZPL_1_ANZ
// KTU_MM_KR_DISTANZPL_5_ANZ
// KTU_MM_KR_DISTANZPL_12_ANZ
export const calculatePlateDistances = () => {
    const result: any = {
        plateDistance1: 0,
        plateDistance5: 0,
        plateDistance12: 0,
    };

    // Helpers for detecting double layer width in Opening Side and Counter Opening Side
    const decorOperningSide = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_BS', contex.ExteriorAccessory);
    // const decorCounterOperningSide = helper.GetDependencyValueCode('KTU_MM_ZIERLEISTENVAR_GBS', contex.ExteriorAccessory);

    let widthValueOpeningSide: number = 0;
    // let widthValueCounterOpeningSide: number = 0;
    const doubleWidthLayer = Number(helper.GetMainCharacteristicValue('CUST_MM_AUFDOPPLUNG', contex.Functions));
    widthValueOpeningSide = decorOperningSide !== 'ZV0' ? doubleWidthLayer : 0;
    // widthValueCounterOpeningSide = decorCounterOperningSide !== 'ZV0' ? doubleWidthLayer : 0;


    const kastenrAussenZylinder = helper.GetDependencyValueCode('CUST_MM_KASTENR_AUSSENZYLINDER', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const numberOfDoorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const doorOpeningWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);

    if (kastenrAussenZylinder !== '1') {
        switch (doorModel) {
            case 'CERT':
                if (numberOfDoorWings === 'D1') {
                    switch (widthValueOpeningSide) {
                        case 0:
                            result.plateDistance1 = 0;
                            result.plateDistance5 = 0;
                            result.plateDistance12 = 0;
                            break;
                        case 10:
                            result.plateDistance1 = 3;
                            result.plateDistance5 = 1;
                            result.plateDistance12 = 0;
                            break;
                        case 15:
                            result.plateDistance1 = 1;
                            result.plateDistance5 = 0;
                            result.plateDistance12 = 1;
                            break;
                    }
                } else {
                    result.plateDistance1 = 0;
                    result.plateDistance5 = 0;
                    result.plateDistance12 = 0;
                }
                break;
            case 'BERT':
            case 'VERT':
                switch (doorOpeningWay) {
                    case 'LI':
                    case 'RI':
                        if (numberOfDoorWings === 'D1') {
                            switch (widthValueOpeningSide) {
                                case 0:
                                    result.plateDistance1 = 1;
                                    result.plateDistance5 = 0;
                                    result.plateDistance12 = 1;
                                    break;
                                case 10:
                                    result.plateDistance1 = 1;
                                    result.plateDistance5 = 2;
                                    result.plateDistance12 = 1;
                                    break;
                                case 15:
                                    result.plateDistance1 = 1;
                                    result.plateDistance5 = 3;
                                    result.plateDistance12 = 1;
                                    break;
                            }
                        } else {
                            result.plateDistance1 = 0;
                            result.plateDistance5 = 0;
                            result.plateDistance12 = 0;
                        }
                        break;
                    case 'LA':
                    case 'RA':
                        result.plateDistance1 = 0;
                        result.plateDistance5 = 0;
                        result.plateDistance12 = 0;
                        break;
                }
                break;
            }
        }

    return result;
};


// KTU_MM_FUNK_ANZ
// KTU_MM_FUNK_SET
// KTU_MM_TRANSPONDER_ANZ
// KTU_MM_TRANSPONDER_SET
export const transponderControlsStatus = () => {
    let result: boolean = false;

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const fireResistant = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);

    const specialLockCustomValue = helper.GetDependencyValueCode('CUST_MM_VERRIEGELUNG_SONDER', contex.ExteriorAccessory);

    // const numberOfDoorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    // const doorOpeningWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);

    switch (doorModel) {
        case 'BERT':
        case 'CERT':
            if (fireResistant === '0') {
                switch (specialLockCustomValue) {
                    case '2':
                    case '6':
                    case '7':
                        result = false;
                        break;
                    default:
                        result = true;
                        break;
                }
            } else {
                result = true;
            }
            break;
        case 'VERT':
            result = true;
            break;
    }

    return result;
};

// CUST_MM_VERRIEGELUNG_SONDER
export const specialLockCustomValues = (): any => {
    // let result: any;
    let valuesList: string[] = ['0'];

    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    // const fireResistant = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const openingWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);
    const escapeDoor = helper.GetDependencyValueCode('KTU_MM_FLUCHT', contex.ModelSelection);
    const panicDoor = helper.GetDependencyValueCode('KTU_MM_PANIK', contex.ModelSelection);
    const functionEN179 = helper.GetDependencyValueCode('KTU_MM_FUNKTION_EN179', contex.ExteriorAccessory);
    const functionEN1125 = helper.GetDependencyValueCode('KTU_MM_FUNKTION_EN1125', contex.ExteriorAccessory);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
    if(resistanceClass !== '4') {
        switch (doorModel) {
            case 'CERT':
            case 'BERT':
                if (escapeDoor === 'JA' || panicDoor === 'JA') {
                    if (escapeDoor === 'JA') {
                        switch (functionEN179) {
                            case 'E':
                                valuesList = ['0', '7', '8'];
                                break;
                            case 'B':
                                valuesList = ['0'];
                                break;
                            default:
                                valuesList = ['0'];
                                break;
                        }
                    } else if (panicDoor === 'JA') {
                        switch (functionEN1125) {
                            case 'E':
                                valuesList = ['0', '6'];
                                break;
                            case 'B':
                                valuesList = ['0'];
                                break;
                            default:
                                valuesList = ['0'];
                                break;
                        }
                    }
                } else {
                    if (doorWings === 'D1') {
                        if (openingWay === 'LI' || openingWay === 'RI') {
                            valuesList = ['0', '1', '2', '9', '3', '4', '5'];
                        } else {
                            valuesList = ['0', '1', '2', '9'];
                        }
                    } else {
                        valuesList = ['0', '1', '2', '9'];
                    }
                }
                break;
            case 'VERT':
                valuesList = ['0'];
                break;
        }
    }else {
        valuesList = ['0'];
    }

    var getter = store.getters['configuratorModule/getCharacteristicItemFromAllInitialCharacteristics']
    const specialLock = getter('CUST_MM_VERRIEGELUNG_SONDER');
    const specialLockCustomCharacteristic = copyObject(specialLock);
    const newValuesList = [];

    for (const iterator of valuesList) {
        const valueItem = specialLockCustomCharacteristic.values.filter((item: any) => item.value === iterator)[0];
        newValuesList.push(valueItem);
    }

    if (newValuesList.length !== 0) {
        specialLockCustomCharacteristic.values = newValuesList;
    }

    return specialLockCustomCharacteristic;
};

// KTU_MM_VERRIEGELUNG_SONDER
export const specialLockLLT = (): ValueDefinition => {

    let lltNumber: string = '0';

    // const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    // const fireResistant = helper.GetDependencyValueCode('KTU_MM_FUNKTION_BH', contex.ModelSelection);
    // const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    // const openingWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);
    const escapeDoor = helper.GetDependencyValueCode('KTU_MM_FLUCHT', contex.ModelSelection);
    const panicDoor = helper.GetDependencyValueCode('KTU_MM_PANIK', contex.ModelSelection);
    const functionEN179 = helper.GetDependencyValueCode('KTU_MM_FUNKTION_EN179', contex.ExteriorAccessory);
    const functionEN1125 = helper.GetDependencyValueCode('KTU_MM_FUNKTION_EN1125', contex.ExteriorAccessory);
    const specialLockCustom = helper.GetDependencyValueCode('CUST_MM_VERRIEGELUNG_SONDER', contex.ExteriorAccessory);

    switch (specialLockCustom) {
        case '0':
            if (escapeDoor === 'JA') {
                switch (functionEN179) {
                    case 'E':
                        lltNumber = 'LLT100098';
                        break;
                    case 'B':
                        lltNumber = 'LLT100099';
                        break;
                }
            } else if (panicDoor === 'JA') {
                switch (functionEN1125) {
                    case 'E':
                        lltNumber = 'LLT100100';
                        break;
                    case 'B':
                        lltNumber = 'LLT100101';
                        break;
                }
            } else {
                lltNumber = '0';
            }
            break;
        case '1':
            lltNumber = 'LLT100091';
            break;
        case '2':
            lltNumber = 'LLT100092';
            break;
        case '3':
            lltNumber = 'LLT100095';
            break;
        case '4':
            lltNumber = 'LLT100096';
            break;
        case '5':
            lltNumber = 'LLT100097';
            break;
        case '6':
            if (escapeDoor === 'JA') {
                lltNumber = 'LLT100093';
            } else if (panicDoor === 'JA') {
                lltNumber = 'LLT100094';
            }
            break;
        case '7':
            lltNumber = 'LLT100093';
            break;
        case '8':
            lltNumber = 'LLT100127';
            break;
        case '9':
            lltNumber = 'LLT100128';
            break;
    }

    let specialLockCharacteristic: any;
    let specialLockValue: ValueDefinition;
    specialLockCharacteristic = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_VERRIEGELUNG_SONDER')[0];
    specialLockValue = specialLockCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return specialLockValue;
};





// KTU_MM_SCHLOSS
export const schloss = (): ValueDefinition => {

    let lltNumber: string = '0';

    const standardLock = helper.GetDependencyValueCode('KTU_MM_VERRIEG_STD', contex.ExteriorAccessory);
    const panicDoor = helper.GetDependencyValueCode('KTU_MM_PANIK', contex.ModelSelection);
    const escapeDoor = helper.GetDependencyValueCode('KTU_MM_FLUCHT', contex.ModelSelection);

    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
    const openingWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);

    const specialLockCustom = helper.GetDependencyValueCode('CUST_MM_VERRIEGELUNG_SONDER', contex.ExteriorAccessory);

    const resistanceClass23 = resistanceClass !== '4' ? true : false;
    const resistanceClass4 = resistanceClass === '4' ? true : false;

    const leftSide = openingWay === 'LI' || openingWay === 'LA' ? true : false;
    const rightSide =  openingWay === 'RI' || openingWay === 'RA' ? true : false;

    if (standardLock === '0') {
        lltNumber = '0';
    } else {
        if (escapeDoor === 'NEIN' && panicDoor === 'NEIN') {
            if (resistanceClass23 === true) {
                lltNumber = 'LLT300009';
            } else if (resistanceClass4 === true) {
                if (rightSide === true) {
                    lltNumber = 'LLT300012';
                } else if (leftSide === true){
                    lltNumber = 'LLT300013';
                }
            }
        } else {
            lltNumber = '0';
        }
    }

    let schlossCharacteristic: any;
    let schlossValue: ValueDefinition;
    const schlossChar = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLOSS')[0];
    schlossCharacteristic = copyObject(schlossChar);
    schlossValue = schlossCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return schlossValue;
};

// KTU_MM_SCHLIESSLEISTE
export const schliessleiste = (): ValueDefinition => {

    let lltNumber: string = '0';

    const standardLock = helper.GetDependencyValueCode('KTU_MM_VERRIEG_STD', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
    const openingWay = helper.GetDependencyValueCode('KTU_MM_AUFGEHRICHTUNG', contex.Functions);

    const leftSide = openingWay === 'LI' || openingWay === 'LA' ? true : false;
    const rightSide =  openingWay === 'RI' || openingWay === 'RA' ? true : false;
    const modelBertVert =  doorModel !== 'CERT' ? true : false;

    if (standardLock === '0' || resistanceClass === '2' || doorModel === 'CERT') {
        lltNumber = '0';
    } else {
        if (modelBertVert && doorWings === 'D1' && resistanceClass === '3' && rightSide === true) {
            lltNumber = 'LLT300010';
        } else if (modelBertVert && doorWings === 'D1' && resistanceClass === '3' && leftSide === true) {
            lltNumber = 'LLT300011';
        } else if (modelBertVert && doorWings === 'D1' && resistanceClass === '4' && rightSide === true) {
            lltNumber = 'LLT300014';
        } else if (modelBertVert && doorWings === 'D1' && resistanceClass === '4' && leftSide === true) {
            lltNumber = 'LLT300015';
        } else {
            lltNumber = '0';
        }
    }

    let schliessleisteCharacteristic: any;
    let schliessleisteValue: ValueDefinition;
    const schliessleisteChar = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_SCHLIESSLEISTE')[0];
    schliessleisteCharacteristic = copyObject(schliessleisteChar);
    schliessleisteValue = schliessleisteCharacteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return schliessleisteValue;
};

// KTU_MM_BANDSICHERUNG
export const bandsicherung = (): ValueDefinition => {

    let lltNumber: string = '0';

    const standardLock = helper.GetDependencyValueCode('KTU_MM_VERRIEG_STD', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);

    // const modelBertVert =  doorModel !== 'CERT' ? true : false;
    // const resistanceClass23 = resistanceClass !== '4' ? true : false;
    // const modelBertCert = doorModel !== 'VERT' ? true : false;

    if (standardLock === '0') {
        lltNumber = '0';
    } else {
        // if (resistanceClass23 === true  && doorModel === 'CERT') {
        //     lltNumber = 'LLT330004';
        // } else if (modelBertVert === true && resistanceClass === '3') {
        //     lltNumber = 'LLT330004';
        // } else {
        //     lltNumber = '0';
        // }
        if((resistanceClass === '2' || resistanceClass === '3') && doorModel === 'CERT') {
            lltNumber = 'LLT330100';
        }
        else if(resistanceClass === '3' && doorModel === 'BERT') {
            lltNumber = 'LLT330100';
        }
        else if(resistanceClass === '3' && doorModel === 'VERT') {
            lltNumber = 'LLT330101';
        }else {
            lltNumber = '0';
        }
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_BANDSICHERUNG')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_STAHLSTULPLEISTE
export const stahlstulplesite = (): ValueDefinition => {

    let lltNumber: string = '0';

    const standardLock = helper.GetDependencyValueCode('KTU_MM_VERRIEG_STD', contex.ExteriorAccessory);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);
    const resistanceClass23 = resistanceClass !== '4' ? true : false;

    if (standardLock === '0') {
        lltNumber = '0';
    } else {
        if (resistanceClass23) {
            lltNumber = '0';
        } else {
            lltNumber = 'LLT330001';
        }
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_STAHLSTULPLEISTE')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_VERR_BOLZEN
export const verrBolzen = (): ValueDefinition => {

    let lltNumber: string = '0';

    const standardLock = helper.GetDependencyValueCode('KTU_MM_VERRIEG_STD', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);

    if (standardLock === '0') {
        lltNumber = '0';
    } else if (resistanceClass === '4' && doorWings === 'D1' ) {
        lltNumber = 'LLT330002';
    } else if (resistanceClass === '4' && doorWings === 'D2' && (doorModel === 'BERT' || doorModel === 'CERT')) {
        lltNumber = 'LLT330002';
    } else {
        lltNumber = '0';
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_VERR_BOLZEN')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_VERR_BSTIFT
export const verrBstift = (): ValueDefinition => {

    let lltNumber: string = '0';

    const standardLock = helper.GetDependencyValueCode('KTU_MM_VERRIEG_STD', contex.ExteriorAccessory);
    const doorModel = helper.GetDependencyValueCode('KTU_MM_MODELL', contex.ModelSelection);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);
    const resistanceClass = helper.GetDependencyValueCode('KTU_MM_FUNKTION_RC', contex.ModelSelection);

    if (standardLock === '0') {
        lltNumber = '0';
    } else if (resistanceClass === '4' && doorWings === 'D1' ) {
        lltNumber = 'LLT330003';
    } else if (resistanceClass === '4' && doorWings === 'D2' && (doorModel === 'BERT' || doorModel === 'CERT')) {
        lltNumber = 'LLT330003';
    } else {
        lltNumber = '0';
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_VERR_BSTIFT')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === lltNumber)[0];

    return value;
};

// KTU_MM_VERR_BSTIFT_ANZ
export const verrBstiftAnz = (): ValueDefinition => {

    let val: string = '0';

    const bstift = helper.GetDependencyValueCode('KTU_MM_VERR_BSTIFT', contex.ExteriorAccessory);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    if (bstift !== '0') {
        switch (doorWings) {
            case 'D1':
                val = '21';
                break;
            case 'D2':
                val = '46';
                break;
        }
    } else {
        val = '0';
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_VERR_BSTIFT_ANZ')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === val)[0];

    return value;
};

// KTU_MM_VERR_BOLZEN_ANZ
export const verrBolzenAnz = (): ValueDefinition => {

    let val: string = '0';

    const bolzen = helper.GetDependencyValueCode('KTU_MM_VERR_BOLZEN', contex.ExteriorAccessory);
    const doorWings = helper.GetDependencyValueCode('KTU_MM_OEFFNUNGSART', contex.ModelSelection);

    if (bolzen !== '0') {
        switch (doorWings) {
            case 'D1':
                val = '21';
                break;
            case 'D2':
                val = '46';
                break;
        }
    } else {
        val = '0';
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_VERR_BOLZEN_ANZ')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === val)[0];

    return value;
};

//KTU_MM_ZUBEHOER
export const getZUBEHOER = (): ValueDefinition => {
    var haveZubehoer = false;
    var result = '';

    const beschlagArt = helper.GetDependencyValueCode('KTU_MM_BESCHLAGSART', contex.ExteriorAccessory);
    const customZylinder = helper.GetDependencyValueCode('CUST_MM_ZYLINDER', contex.ExteriorAccessory);
    //const zusatzschluesslPieces = helper.GetDependencyValueCode('KTU_MM_ZUSATZSCHLUESSEL_ANZ', contex.ExteriorAccessory);  CHECK AGAIN
    const spion = helper.GetDependencyValueCode('CUST_MM_SPION', contex.ExteriorAccessory);
    const sicherungskette = helper.GetDependencyValueCode('KTU_MM_SICHERUNGSKETTE', contex.ExteriorAccessory);

    const kastenRiegelschloss = helper.GetDependencyValueCode('CUST_MM_KASTENR_AUSSENZYLINDER', contex.ExteriorAccessory);

    const kastenRiegelschlossFarbe = helper.GetDependencyValueCode('CUST_MM_KASTENRIEGELSCHLOSS_FARBE', contex.ExteriorAccessory);
    const turfeststeller = helper.GetDependencyValueCode('KTU_MM_TUERFESTSTELLER', contex.ExteriorAccessory);
    const haftmagnet = helper.GetDependencyValueCode('KTU_MM_HAFTMAGNET', contex.ExteriorAccessory);
    const Kabelkanalubergang =  helper.GetDependencyValueCode('CUST_MM_KABELKANALUEBERGANG', contex.ExteriorAccessory);
    const Wandturpuffer = helper.GetDependencyValueCode('KTU_MM_BODEN_WANDTUERPUFFER', contex.ExteriorAccessory);
    const Reedkontakt = helper.GetDependencyValueCode('KTU_MM_REEDKONTAKT', contex.ExteriorAccessory);


    const Riegelschaltkontakt = helper.GetDependencyValueCode('KTU_MM_RIEGELSCHALTKONTAKT', contex.ExteriorAccessory);
    const Fingerscanner = helper.GetDependencyValueCode('KTU_MM_FINGERSCANNER', contex.ExteriorAccessory);

    // const Sonderverriegelungen = helper.GetDependencyValueCode('CUST_MM_VERRIEGELUNG_SONDER', contex.ExteriorAccessory);
    const Absenkdichtung = helper.GetDependencyValueCode('KTU_MM_ABSENKDICHTUNG', contex.Measure)
    const TRANSPONDER = helper.GetDependencyValueCode('CUST_MM_TRANSPONDER_FUNK', contex.ExteriorAccessory);

    // const EOffner  = helper.GetDependencyValueCode('CUST_MM_EOEFFNER', contex.ExteriorAccessory); //has to change to KTU's
    const EOffner  = helper.GetDependencyValueCode('KTU_MM_EOEFFNER_1', contex.ExteriorAccessory);
    // const Oberkopfschliecher = helper.GetDependencyValueCode('CUST_MM_TUERSCHLIESSER', contex.ExteriorAccessory); //has to change to KTU's
    const Oberkopfschliecher = helper.GetDependencyValueCode('KTU_MM_TUERSCHLIESSER_1', contex.ExteriorAccessory);

    if(beschlagArt !== 'BESCHLAG BAUSEITIG' && beschlagArt !== 'BESCHLAG NACH ABSPRACHE')
    {
        haveZubehoer = true;
    }
    if(customZylinder != '1')
    {
        haveZubehoer = true;
    }
    if(spion !== '0')
    {
        haveZubehoer = true;
    }
    if(sicherungskette !== '0')
    {
        haveZubehoer = true;
    }
    if(kastenRiegelschloss !== '1')
    {
        haveZubehoer = true;
    }

    if(kastenRiegelschlossFarbe !== '1')
    {
        haveZubehoer = true;
    }

    if(turfeststeller !== '0')
    {
        haveZubehoer = true;
    }
    if(haftmagnet !== '0')
    {
        haveZubehoer = true;
    }
    if(Kabelkanalubergang !== '1')
    {
        haveZubehoer = true;
    }
    if(Wandturpuffer !== '0')
    {
        haveZubehoer = true;
    }
    if(Reedkontakt !== '0')
    {
        haveZubehoer = true;
    }
    if(Riegelschaltkontakt !== 'NEIN')
    {
        haveZubehoer = true;
    }
    if(Fingerscanner !== 'NEIN')
    {
        haveZubehoer = true;
    }
    // if(Sonderverriegelungen !== '0')
    // {
    //     haveZubehoer = true;
    // }
    if(Absenkdichtung !== '0'){
        haveZubehoer = true
    }
    if(TRANSPONDER !== '0')
    {
        haveZubehoer = true;
    }
    if(EOffner !== 'KEIN')
    {
        haveZubehoer = true;
    }
    if(Oberkopfschliecher !== 'KEIN')
    {
        haveZubehoer = true;
    }

    if(haveZubehoer)
    {
        result = 'LLT100089'
    }else {
        result = '0'
    }

    let characteristic: any;
    let value: ValueDefinition;
    const char = store.state.exteriorAccessoryModule.model.characteristics.filter((c: any) => c.code === 'KTU_MM_ZUBEHOER')[0];
    characteristic = copyObject(char);
    value = characteristic.values.filter((v: ValueDefinition) => v.value === result)[0];
    return value;
}